type LookGroupWorkspaceHeaderProps = {
  workflowLine: string;
  brandName?: string | null;
  productName?: string | null;
  productId?: string | null;
  productColor?: string | null;
};

const LookGroupWorkspaceHeader = ({
  workflowLine,
  brandName,
  productName,
  productId,
  productColor,
}: LookGroupWorkspaceHeaderProps) => {
  const compactMeta = [brandName, productId, productColor].filter(Boolean).join(' • ');

  return (
    <header className="sticky top-(--look-groups-toolbar-height) z-30 h-(--look-group-header-height) border-b border-border/60 px-3 backdrop-blur-lg ">
      <div className="grid h-full grid-cols-[minmax(0,1fr)_auto] items-center gap-4">
        <div className="min-w-0 space-y-0.5">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[9px] font-medium tracking-[0.14em] text-muted-foreground uppercase">
            <span>{workflowLine || 'No occasion scope'}</span>
            {compactMeta ? (
              <>
                <span>•</span>
                <span>{compactMeta}</span>
              </>
            ) : null}
          </div>

          <h2 className="m-0 line-clamp-1 text-[13px] font-semibold tracking-tight text-foreground">
            {productName || productId || 'Look Group'}
          </h2>
        </div>
      </div>
    </header>
  );
};

export default LookGroupWorkspaceHeader;
